export default "__VITE_ASSET__BXUzBcYU__"